<template>
    <div class="form">
        <div class="title">
            {{ `${room.parkName}${room.floorName}${room.houseNum}` }}
        </div>
        <div class="filte">
            <check-tag-group
                style="display: inline-block"
                v-model="filter.meterTypes"
                color="primary"
                @on-change="search"
                multiple
            >
                <check-tag
                    v-for="item in dict.meterType.toList()"
                    :name="item.id"
                    :key="item.id"
                    >{{ item.text }}</check-tag
                >
            </check-tag-group>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>

            <Table
                style="margin-top: 20px"
                ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight"
            >
                <template v-slot:dosage="{ row }">
                    {{
                        row.dosage
                            ? row.dosage +
                              `${hashMap[dict.meterType.val(row.meterType)]}`
                            : '0' +
                              `${hashMap[dict.meterType.val(row.meterType)]}`
                    }}
                </template>

                <template v-slot:price="{ row }">
                    {{ (row.price / 100) | currency }}
                    {{ hashsMap[dict.meterType.val(row.meterType)] }}
                </template>
                <template v-slot:amount="{ row }">
                    {{ (row.amount / 100) | currency }}
                </template>
                <template v-slot:createTime="{ row }">
                    {{ row.createTime | ymdL }}
                </template>
                <template v-slot:planDate="{ row }">
                    {{ row.planDate | ymd }}
                </template>
            </Table>
            <table-pager
                :total="page.totalCount"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.page"
                @change="fetch"
            >
            </table-pager>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import { housemeterList } from '@/api/bill-list'
import Dict from '_u/dict'
import FilterDateRange from '_v/components/filter/filter-date-range'

export default {
    name: 'meterRecordForm',
    inject: {
        $modal: {
            default: null,
        },
    },
    props: {
        room: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        FilterDateRange,
    },
    data() {
        return {
            mtHeight: 320,
            loading: false,
            filter: {
                houseId: this.room.id,
                meterTypes: [1, 2, 3],
                startDate: '',
                endDate: '',
            },
            page: {
                totalCount: 0,
                list: [],
            },
            dict: {
                meterType: Dict.NULL,
            },
            hashMap: {
                水表: '吨',
                电表: '度',
                燃气表: '立方米',
            },
            hashsMap: {
                水表: '元/吨',
                电表: '元/度',
                燃气表: '元/立方米',
            },
        }
    },
    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '表名称',
                    key: 'meterName',
                    align: 'left',
                    minWidth: 80,
                },

                {
                    title: '读数',
                    key: 'degree',
                    align: 'right',
                    minWidth: 80,
                    tooltip: true,
                },

                {
                    title: '用量',
                    key: 'dosage',
                    align: 'right',
                    minWidth: 80,
                    slot: 'dosage',
                    tooltip: true,
                },
                {
                    title: '单价',
                    key: 'price',
                    align: 'right',
                    minWidth: 100,
                    slot: 'price',
                    tooltip: true,
                },
                {
                    title: '应收',
                    key: 'amount',
                    align: 'right',
                    minWidth: 80,
                    slot: 'amount',
                    tooltip: true,
                },
                {
                    title: '应收款日',
                    key: 'amount',
                    align: 'center',
                    minWidth: 120,
                    slot: 'planDate',
                    tooltip: true,
                },

                {
                    title: '抄表时间',
                    key: 'createTime',
                    align: 'center',
                    minWidth: 150,
                    slot: 'createTime', // createTime
                    tooltip: true,
                },
            ]
        },
    },
    methods: {
        getMeter() {},
        fetch() {
            if (this.filter.meterTypes.length == 0) {
                this.$Message.error('请至少选择一个抄表')
            } else {
                this.loading = true
                Promise.all([
                    housemeterList({
                        houseId: this.filter.houseId,
                        meterTypes: this.filter.meterTypes.join(','),
                        startDate: this.filter.startDate,
                        endDate: this.filter.endDate,
                    }),
                    Dict.get(['meter_type']),
                ])
                    .then((args) => {
                        var [view, dictGroup] = args
                        Object.keys(this.dict).forEach((name) => {
                            this.dict[name] = dictGroup[name]
                        })
                        this.setPageData(view)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        setPageData(res) {
            var list = res.data.page.list
            this.page.list = list
            this.page.totalCount = parseInt(res.data.page.totalCount)
        },
        search() {
            this.filter.page = 1
            this.fetch()
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        // 按钮配置
        var btns = [{ type: 'default', text: '关闭', name: 'cancel' }]

        this.$modal.updateBtns(btns)
    },
    watch: {
        'filter.meterTypes': {
            handler(val, oldVal) {
                if (val.length === 0) {
                    this.filter.meterTypes = oldVal
                }
            },
        },
    },
}
</script>

<style lang="less" scoped>
.title {
    font-size: 18px;
    margin-bottom: 15px;
}
</style>
